/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EmotionStrictHttpResponse } from '../../emotion-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmotionRequestModel } from '../../models/emotion-request-model';
import { EmotionsHistoryResponse } from '../../models/emotions-history-response';

export interface ConsumerEmotionPost$Params {
      body?: EmotionRequestModel
}

export function consumerEmotionPost(http: HttpClient, rootUrl: string, params?: ConsumerEmotionPost$Params, context?: HttpContext): Observable<EmotionStrictHttpResponse<Array<EmotionsHistoryResponse>>> {
  const rb = new RequestBuilder(rootUrl, consumerEmotionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as EmotionStrictHttpResponse<Array<EmotionsHistoryResponse>>;
    })
  );
}

consumerEmotionPost.PATH = '/Consumer/Emotion';
